import { handleFromInput } from '@peach/types/instagram/handle.js';

/**
 * What the landing's handle field shows for what was typed or pasted: always one leading `@`,
 * a pasted profile link turned into its handle. A link still being typed, or one that names no
 * profile (a post), is left as it is: `/agent` says what is wrong with it.
 */
export function handleField(raw: string): string {
  const text = raw.replace(/\s+/g, '');
  if (/[/:]/.test(text)) {
    const handle = handleFromInput(text.replace(/^@+/, ''));
    return handle ? `@${handle}` : text;
  }
  const bare = text.replace(/^@+/, '').toLowerCase();
  return bare ? `@${bare}` : '';
}
